<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px">
      <div class="fl">
        <el-button type="primary" @click="bind()" size="mini">绑定</el-button>
        <el-input v-model="search.platformName" placeholder="输入场站名称" size="mini" style="width: 150px; margin: 0 10px"
          @change="init()" clearable></el-input>
        <el-input v-model="search.tenantName" placeholder="输入企业名称" size="mini" style="width: 150px;" @change="init()"
          clearable></el-input>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="80%" v-loading="loading"
      highlight-current-row>
      <template slot="empty">
        <el-empty></el-empty>
      </template>
      <el-table-column prop="platformName" label="场站名称" min-width="180" show-overflow-tooltip
        align="center"></el-table-column>
      <el-table-column prop="tenantName" label="企业名称" min-width="180" show-overflow-tooltip
        align="center"></el-table-column>
      <el-table-column fixed="right" width="400" label="操作" align="center">
        <template v-slot="scope">
          <el-button size="mini" type="text" @click="unBind(scope.row)">解除绑定</el-button>
        </template>
      </el-table-column>
    </el-table>
    <detail ref="detail" @init="search = {}; init()" />
  </div>
</template>

<script>
import detail from './components/detail'

export default {
  data() {
    return {
      data: [],
      allAlign: 'center',
      loading: false,
      tableHeight: window.innerHeight - 238 + 'px',
      search: {
        platformName: '',
        tenantName: ''
      }
    }
  },
  components: { detail },
  created() {
    this.init()
  },
  mounted() {
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.$set(this, 'loading', true)
      const params = {
        params: {}
      }
      for (let key in this.search) {
        if (this.search[key])
          params.params[key] = this.search[key]
      }
      this.$axios.get('/account/platform/bind/list', params).then(res => {
        this.data = res.data.data
        this.loading = false
      }).catch(err => {
        console.log('model Err:', err)
        this.$set(this, 'loading', false)
      })
    },

    bind() {
      this.$refs.detail.display()
    },

    unBind(row) {
      this.$confirm(`确定解除绑定吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$axios.get(`/account/platform/bindInfoDel/${row.id}`).then(() => {
          this.$message.success(`解除绑定成功`)
          this.init()
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.cf {
  overflow: hidden
}

.fl {
  float: left;
}

.fr {
  float: right;
}
</style>
